// src/reducers/index.js

import { combineReducers } from "redux";

import { alert } from "./alert.reducer";
import { authentication } from "./authentication.reducer";
import { maintenanceMessage } from "./maintenance.reducer";
import { partCreator } from "./partCreator.reducer";
import { pbhrepair } from "./pbhrepair.reducer";
import { priceLine } from "./priceLine.reducer";
import { prioritiesOrder } from "./prioritiesOrder.reducer";
import { repairPartNumberUpdate } from "./repairPartNumberUpdate.reducer";
import { salesgraphs } from "./salesgraphs.reducer";
import { salesorder } from "./salesorder.reducer";
import { statusesOrder } from "./statusesOrder.reducer";
import { statusesRepairs } from "./statusesRepairs.reducer";
import { users } from "./users.reducer";
import { pbhApi } from "../services/pbhApi";

const rootReducer = combineReducers({
  authentication,
  partCreator,
  users,
  alert,
  salesorder,
  pbhrepair,
  statusesOrder,
  salesgraphs,
  prioritiesOrder,
  statusesRepairs,

  priceLine,
  repairPartNumberUpdate,
  maintenanceMessage,
  [pbhApi.reducerPath]: pbhApi.reducer,
});

export default rootReducer;
